import * as Yup from 'yup'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { SettlementAPI } from '../../../../api'
import { makeStyles } from '@material-ui/core/styles'
import { Form, WrapperForm, Container, WrapperButton, Label, Asterisk } from './activity.styled'
import { Input, InputSelect, MasterModal, Button } from '../../../../components'



const AddTaskModal = ({ activity, setIsLoading, addNewTask, handleClose }) => {
  const [taskLevel, setTaskLevel] = React.useState([])

  const useStyles = makeStyles({
    customInput: {
      '& .MuiInputBase-root': {
        height: '32px',
      },
    },
    customSelectInput: {
      '& .MuiAutocomplete-endAdornment': {
        top: 'auto'
      },
      '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        padding: '0px 0px 0px 9px',
      }
    }
  })
  const classes = useStyles()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Task_Name: '',
      PIC: '',
      Requirement: '',
      Compliance_Parameter: '',
      Level: undefined,
    },
    validationSchema: Yup.object({
      Task_Name: Yup.string().required('*Task Name is required*').trim(),
    }),
    onSubmit: async (values) => {
      const formData = { ...values }
      try {
        setIsLoading(true)
        await addNewTask(activity, '', true, formData)
      } catch (err) {
        console.error('Error adding task:', err)
      } finally {
        setIsLoading(false)
      }
    },
  })

  const getTaskLevel = async () => {
    try {
      const filterString =
        '[{"field":"type","type":"text","value":"Task_Level"},{"field":"is_active","type":"bool","value":"true"}]'
      const response = await SettlementAPI.GetAllFromTableEnum(0, 10, filterString)

      setTaskLevel(response.data || [])
    } catch (error) {
      console.error(error)
    }
  }

  const handleCancel = () => {
    formik.resetForm()
    formik.setSubmitting(false)
    handleClose()
  }

  useEffect(() => {
    getTaskLevel()
  }, [])

  return (
    <div>
      <MasterModal
        id='m_add_task_mdl'
        maxWidth='lg'
        width={33}
        showModal
        title='Add Task'
        isDetail
        hasSubtitle={false}
        handleClose={handleCancel}
        handleSave={formik.handleSubmit}
      >
        <Container>
          <Form>
            <WrapperForm>
              <Label>Task Name<Asterisk>*</Asterisk></Label>
              <Input
                fullWidth
                variant='outlined'
                form={formik}
                name='Task_Name'
                placeholder='Task Name'
                id='m_actv_task_name_txt'
                inputProps={{ tabIndex: 1 }}
                className={classes.customInput}
              />
            </WrapperForm>
          </Form>
          <Form>
            <WrapperForm>
              <Label>PIC</Label>
              <Input
                fullWidth
                variant='outlined'
                form={formik}
                name='PIC'
                placeholder='PIC'
                id='m_actv_pic_txt'
                inputProps={{ tabIndex: 3 }}
                className={classes.customInput}
              />
            </WrapperForm>
            <WrapperForm>
              <Label>Level</Label>
              <InputSelect
                fullWidth
                variant='outlined'
                id='level_txt'
                placeholder='Level'
                name='Level'
                options={taskLevel}
                optionText='Value'
                optionValueKey='Code'
                form={formik}
                tabIndex={2}
                customAutocompleteProps={{
                  className: classes.customSelectInput
                }}
                customTextFieldProps={{
                  variant: 'outlined',
                  className: classes.customInput
                }}
              />
            </WrapperForm>
          </Form>
          <Form>
            <WrapperForm>
              <Label>Requirement</Label>
              <Input
                fullWidth
                variant='outlined'
                type='text'
                rowsMax={3}
                multiline
                form={formik}
                name='Requirement'
                placeholder='Requirement'
                id='m_actv_requirement_txt'
              />
            </WrapperForm>
            <WrapperForm>
              <Label>Compliance Parameter</Label>
              <Input
                fullWidth
                variant='outlined'
                type='text'
                rowsMax={3}
                multiline
                form={formik}
                name='Compliance_Parameter'
                placeholder='Compliance Parameter'
                id='m_actv_compliance_txt'
              />
            </WrapperForm>
          </Form>
          <WrapperButton>
            <Button
              borderColor
              id='m_add_task_cancel_btn'
              variant='outlined'
              color='transparent'
              size='small'
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              id='m_add_task_btn'
              type='submit'
              variant='contained'
              color='blue'
              size='small'
              onClick={formik.handleSubmit}
            >
              Add
            </Button>
          </WrapperButton>
        </Container>
      </MasterModal>
    </div>
  )
}

AddTaskModal.propTypes = {
  activity: PropTypes.object.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  addNewTask: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default AddTaskModal